import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import {
  NavBar,
  LoaderIndicator,
  HelperViewStatus,
  Heading,
  ListDisplay,
  BaseText,
  MessageFoundation as Message,
  ChipStatus
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';
import { Money } from '@/modules/common/components/Money';
import { EFontStyle } from './types';
import {
  getCostsDetails,
  ICostsDetails,
  ILabelValue
} from '@/modules/cash/services/costs-v2';
interface Props {
  year: string;
  month: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CostsDetails',
  props: {
    year: null,
    month: null
  },
  setup(__props: any) {

const { year, month } = __props as {
  year: string;
  month: string;
}


const router = useRouter();
const hasError = ref(false);
const isLoading = ref(false);
const costsDetails = ref<ICostsDetails | null>(null);
function onBack() {
  router.push({ name: 'costs' });
}
function titleColor(item: ILabelValue) {
  if (item.fontStyle === EFontStyle.bold) return NebraskaColors.elementPrimary;
  if (item.fontStyle === EFontStyle.green)
    return NebraskaColors.monetaryPositive;
  return NebraskaColors.elementSecondary;
}
function valueColor(item: ILabelValue) {
  if (item.fontStyle === EFontStyle.bold) return NebraskaColors.elementPrimary;
  return NebraskaColors.elementSecondary;
}
function showChip(value: string) {
  return value === 'Em aberto';
}
async function fetchCostsDetails() {
  try {
    hasError.value = false;
    isLoading.value = true;
    costsDetails.value = await getCostsDetails(year, month);
  } catch (e) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}
onMounted(async () => {
  await fetchCostsDetails();
});

return { __sfc: true,router, hasError, isLoading, costsDetails, onBack, titleColor, valueColor, showChip, fetchCostsDetails, NavBar, LoaderIndicator, HelperViewStatus, Heading, ListDisplay, BaseText, Message, ChipStatus, BackButton, ShowMoneyToggleButton, Money }
}

})